export default __webpack_public_path__ + "static/media/menu-video.1c6d4d09.svg";